import React,{Component} from 'react';
import { ContentState,EditorState,convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { stateToHTML } from "draft-js-export-html";
import './styles.css';
export default class WysiwygEditor extends Component
{
    

    state={
        editorState: null,
        updated:false
    }
    componentWillReceiveProps(newProps)
    {
        if(newProps.value&&!this.state.updated)
            this._setValue(newProps.value);
    }
    _setValue=(value)=>
    {
        const blocksFromHTML = convertFromHTML(value||"");
        const newState=ContentState.createFromBlockArray(blocksFromHTML);
        const editorState =newState.getBlockMap().first()?EditorState.createWithContent(newState):EditorState.createEmpty();
        this.setState({editorState})
    }
    componentWillMount()
    {
        this._setValue(this.props.value);
    }
    render()
    {
        return <div className={`form-group ${this.props.invalid&&"error"} ${this.props.value!=""&&this.props.floatingTitle&&"with-title"}`}>
        <Editor textAlignment="left" editorState={this.state.editorState} onEditorStateChange={(state)=>{
            this.setState({editorState:state,updated:true},()=>this.props.onChange({target:{
                name:this.props.name,
                value:stateToHTML(state.getCurrentContent())
            }}))
            }} wrapperClassName="wysiwyg-editor-wrapper" toolbarClassName="wysiwyg-editor-toolbar" editorClassName="wysiwyg-editor" readOnly={this.props.disabled}
                toolbar={
                    { options: ['inline', 'blockType', 'list', 'textAlign', 'colorPicker', 'link', 'emoji', 'history'] }
                }    />
        {!this.props.invalid&&this.props.hint&&<div className="input-hint">{this.props.hint}</div>}{this.props.invalid&&this.props.error&&<div className="input-error">{this.props.error}</div>}
    </div>;
    }
    
}